import { toast } from "react-toastify";
import { TOAST_DURATION } from "./constants";
import { ErrorToastMessagesE } from "../../data/toastMessages";

const showErrorToast = (text: string = ErrorToastMessagesE.SOMETHING_WENT_WRONG) => {
  // replace default answer from server
  const errorText =
    text === ErrorToastMessagesE.EMAIL_OR_PASSWORD_IS_INCORRECT
      ? ErrorToastMessagesE.INVALID_LOGIN_OR_PASSWORD
      : text;

  toast(errorText, {
    type: "error",
    autoClose: TOAST_DURATION,
  });
};

export default showErrorToast;